var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"recharge-box"}},[_c('div',{attrs:{"id":"recharge-box-mj"}},[_c('a',{staticClass:"close",attrs:{"href":"javascript:;","id":"recharge-close"},on:{"click":function($event){return _vm.closeRecharge()}}}),_c('iframe',{attrs:{"src":_vm.src,"id":"pay-container"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }